import { StockType } from 'types/stock'

export const FETCH_STOCKS = 'FETCH_STOCKS'
export const fetchStocksAction = (stocks: StockType[]) => {
  return {
    type: 'FETCH_STOCKS',
    payload: stocks,
  }
}

export const INIT_STOCKS = 'INIT_STOCKS'
export const initStocksAction = () => {
  return {
    type: 'INIT_STOCKS',
    payload: null,
  }
}

export const SET_STOCK_UNSUBSCRIBE = 'SET_STOCK_UNSUBSCRIBE'
export const setStockUnsubscribeAction = (unsubscribe: () => void) => {
  return {
    type: 'SET_STOCK_UNSUBSCRIBE',
    payload: unsubscribe,
  }
}

export const INIT_STOCK_UNSUBSCRIBE = 'INIT_STOCK_UNSUBSCRIBE'
export const initStockUnsubscribeAction = () => {
  return {
    type: 'INIT_STOCK_UNSUBSCRIBE',
    payload: undefined,
  }
}
